import { render, staticRenderFns } from "./SkinBox.vue?vue&type=template&id=148bd5d4&scoped=true&"
import script from "./SkinBox.vue?vue&type=script&lang=js&"
export * from "./SkinBox.vue?vue&type=script&lang=js&"
import style0 from "./SkinBox.vue?vue&type=style&index=0&id=148bd5d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148bd5d4",
  null
  
)

export default component.exports